import type { VisitDto } from "@repo/data-store";

export function visitCompletionReason(
  visit: Pick<VisitDto, "kind">,
  orderSet: { orders: readonly { status: string }[] } | undefined,
): string | undefined {
  if (visit.kind === "consultation") return undefined;
  if (!orderSet) return "Loading visit orders";
  return undefined;
}
